import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class ScrollHelperService {
  public scrollTo(xPosition: number, yPosition: number): void {
    window.scrollTo(xPosition, yPosition)
  }
}
